import { render, staticRenderFns } from "./JVxeTextareaCell.vue?vue&type=template&id=338968bc&scoped=true&"
import script from "./JVxeTextareaCell.vue?vue&type=script&lang=js&"
export * from "./JVxeTextareaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338968bc",
  null
  
)

export default component.exports